const TOKEN_KEY = 'token'
const VENDOR_ID_KEY = 'vendorId'

export const tokenStorage = {
  getToken: (): string | null => {
    if (typeof window === 'undefined') return null
    return localStorage.getItem(TOKEN_KEY)
  },

  setToken: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token)
  },

  removeToken: (): void => {
    localStorage.removeItem(TOKEN_KEY)
  },

  getVendorId: (): string | null => {
    if (typeof window === 'undefined') return null
    return localStorage.getItem(VENDOR_ID_KEY)
  },

  setVendorId: (vendorId: string): void => {
    localStorage.setItem(VENDOR_ID_KEY, vendorId)
  },

  removeVendorId: (): void => {
    localStorage.removeItem(VENDOR_ID_KEY)
  },

  clearAll: (): void => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(VENDOR_ID_KEY)
  },

  isAuthenticated: (): boolean => {
    return !!tokenStorage.getToken()
  },
}
